import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Modal from 'react-modal';

import modalStyles from './ModalWrapper.scss';

const ModalWrapper = ({
  className,
  overlayClassName,
  children,
  isOpen,
  closeModal,
  transitionType,
  shouldCloseOnOverlayClick,
  additionalClassName,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    contentLabel="Modal Wrapper"
    ariaHideApp={false}
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    className={classNames(`${className}`, additionalClassName)}
    overlayClassName={`${overlayClassName}`}
  >
    {children({ isOpen, closeModal })}
  </Modal>
);

ModalWrapper.propTypes = {
  className: PropTypes.string,
  additionalClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  children: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  transitionType: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
};

ModalWrapper.defaultProps = {
  className: modalStyles.container,
  additionalClassName: '',
  overlayClassName: modalStyles.overlay,
  transitionType: '',
  shouldCloseOnOverlayClick: true,
};

export default ModalWrapper;
